export const SCA_SET_SIDEBAR = 'SCA_SET_SIDEBAR';
export const SCA_SET_VIEW = 'SCA_SET_VIEW';
export const SCA_SET_FILTERS = 'SCA_SET_FILTERS';
export const SCA_SET_FILTERS_DATA = 'SCA_SET_FILTERS_DATA';
export const SCA_SET_FILTERS_LOADING = 'SCA_SET_FILTERS_LOADING';
export const SCA_SET_GRID = 'SCA_SET_GRID';
export const SCA_SET_DATA = 'SCA_SET_DATA';
export const SCA_SET_ROW = 'SCA_SET_ROW';
export const SCA_SET_ROW_VIDEO = 'SCA_SET_ROW_VIDEO';
export const SCA_SET_LOADING = 'SCA_SET_LOADING';
export const SCA_SET_GRID_LOADING = 'SCA_SET_GRID_LOADING';
export const SCA_SET_GRID_RELOAD_DATA = 'SCA_SET_GRID_RELOAD_DATA';
export const SCA_SET_GRID_DATA = 'SCA_SET_GRID_DATA';
export const SCA_SET_TOTAL_ROWS = 'SCA_SET_TOTAL_ROWS';
export const SCA_SET_LAST_PAGE = 'SCA_SET_LAST_PAGE';
export const SCA_SET_MODAL_DETAILS = 'SCA_SET_MODAL_DETAILS';
export const SCA_SET_DATA_GRID_ONLY_ROWS_OF_INTEREST =
  'SCA_SET_DATA_GRID_ONLY_ROWS_OF_INTEREST';
